import React from 'react';
import { Card, CardBody } from 'reactstrap';

const StatCardAdvance = ({
    title,
    currentValue = 0,
    previousValue,
    subtitle,
    icon,
    isCurrency = false,
    isPercentage = false
}) => {
    const current = Number(currentValue) || 0;

    // Formata o número para exibição
    const displayValue = isCurrency
        ? current.toLocaleString("pt-BR", { style: "currency", currency: "BRL" })
        : isPercentage
        ? `${current.toFixed(1)}%`
        : current;

    // Se temos valor prévio, calculamos
    const hasPrevious = typeof previousValue !== "undefined" && previousValue !== null;
    const prev = Number(previousValue) || 0;

    let percentChange = 0;
    if (prev > 0) percentChange = ((current - prev) / prev) * 100;
    else if (current > 0) percentChange = 100;

    const absChange = Math.abs(percentChange).toFixed(1);
    const isPositive = percentChange >= 0;
    const percentIcon = isPositive ? "mdi-arrow-up" : "mdi-arrow-down";

    return (
        <Card className="border-0 shadow-sm overflow-hidden h-100" style={{ borderRadius: "4px" }}>
            <CardBody className="py-3 px-4 d-flex flex-column h-100">
                <div>
                    <div className="d-flex align-items-center justify-content-between mb-3">
                        <p className="text-primary text-uppercase font-size-11 fw-bold mb-0" style={{ letterSpacing: "0.5px" }}>
                            {title}
                        </p>
                        <div
                            className="bg-primary bg-opacity-10 text-primary rounded-circle d-flex align-items-center justify-content-center"
                            style={{ width: "38px", height: "38px", minWidth: "38px" }}
                        >
                            <i className={`${icon} font-size-18`}></i>
                        </div>
                    </div>

                    <h4 className="mb-1 fw-bold text-dark" style={{ fontSize: "24px" }}>
                        {displayValue}
                    </h4>

                    {subtitle && <p className="text-muted font-size-12 mb-0 mt-1">{subtitle}</p>}
                </div>

                <div className="mt-auto">
                    {hasPrevious ? (
                        <div className="mt-3 pt-3 border-top d-flex align-items-center justify-content-between">
                            <span className="text-muted font-size-12">
                                M. anterior: <strong className="text-dark">
                                    {isCurrency 
                                        ? prev.toLocaleString("pt-BR", { style: "currency", currency: "BRL" }) 
                                        : isPercentage 
                                        ? `${prev.toFixed(1)}%` 
                                        : prev}
                                </strong>
                            </span>
                            <div className={`badge bg-primary bg-opacity-10 text-primary fw-bold font-size-11 px-2 py-1`}>
                                <i className={`mdi ${percentIcon} me-1`}></i>
                                {isPositive ? "+" : "-"}{absChange}%
                            </div>
                        </div>
                    ) : (
                        <div className="mt-3 pt-3" style={{ height: "43px" }}></div>
                    )}
                </div>
            </CardBody>
        </Card>
    );
};

export default StatCardAdvance;
